import { useConfig as hook } from '@eika-infrastruktur/config-provider';
import { nbTranslations, nnTranslations } from './translations';
export const defaultConfig = {
    links: {
        redirectURL: {
            url: 'https://www.eika.no',
        },
    },
    siteLang: 'nb',
    translations: {
        nb: nbTranslations,
        nn: nnTranslations,
    },
};
function createHook() {
    return () => hook();
}
export const resourcePath = '/dagligbank-customer-consent-web/rest/resource';
export const useConfig = createHook();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmYXVsdENvbmZpZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9kZWZhdWx0Q29uZmlnLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxTQUFTLElBQUksSUFBSSxFQUFjLE1BQU0scUNBQXFDLENBQUM7QUFFcEYsT0FBTyxFQUEwQixjQUFjLEVBQUUsY0FBYyxFQUFFLE1BQU0sZ0JBQWdCLENBQUM7QUFtQnhGLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBVztJQUNqQyxLQUFLLEVBQUU7UUFDSCxXQUFXLEVBQUU7WUFDVCxHQUFHLEVBQUUscUJBQXFCO1NBQzdCO0tBQ0o7SUFDRCxRQUFRLEVBQUUsSUFBYTtJQUN2QixZQUFZLEVBQUU7UUFDVixFQUFFLEVBQUUsY0FBYztRQUNsQixFQUFFLEVBQUUsY0FBYztLQUNyQjtDQUNKLENBQUM7QUFFRixTQUFTLFVBQVU7SUFDZixPQUFPLEdBQUcsRUFBRSxDQUFDLElBQUksRUFBSyxDQUFDO0FBQzNCLENBQUM7QUFFRCxNQUFNLENBQUMsTUFBTSxZQUFZLEdBQUcsZ0RBQWdELENBQUM7QUFFN0UsTUFBTSxDQUFDLE1BQU0sU0FBUyxHQUFHLFVBQVUsRUFBd0IsQ0FBQyJ9